import React, { useEffect, useState } from "react";
import "../../../css/Views/UpdateModal.css";

const UpdateConsumablesModal = ({ isOpen, initial, onClose, onSubmit }) => {
  const [stickersLarge, setStickersLarge] = useState("0");
  const [stickersSmall, setStickersSmall] = useState("0");
  const [patches, setPatches] = useState("0");
  const [businessCards, setBusinessCards] = useState("0");
  const [pinMetalClasp, setPinMetalClasp] = useState("0");
  const [pinScrewBack, setPinScrewBack] = useState("0");
  const [pinPlasticClasp, setPinPlasticClasp] = useState("0");
  const [pinCards, setPinCards] = useState("0");
  const [note, setNote] = useState("");

  useEffect(() => {
    if (isOpen) {
      setStickersLarge(initial.stickersLarge?.toString() ?? "0");
      setStickersSmall(initial.stickersSmall?.toString() ?? "0");
      setPatches(initial.patches?.toString() ?? "0");
      setBusinessCards(initial.businessCards?.toString() ?? "0");
      setPinMetalClasp(initial.pinMetalClasp?.toString() ?? "0");
      setPinScrewBack(initial.pinScrewBack?.toString() ?? "0");
      setPinPlasticClasp(initial.pinPlasticClasp?.toString() ?? "0");
      setPinCards(initial.pinCards?.toString() ?? "0");
      setNote("");
    }
  }, [isOpen, initial]);

  if (!isOpen) return null;

  const handleSubmit = () => {
    onSubmit({
      stickersLarge: Number(stickersLarge || 0),
      stickersSmall: Number(stickersSmall || 0),
      patches: Number(patches || 0),
      businessCards: Number(businessCards || 0),
      pinMetalClasp: Number(pinMetalClasp || 0),
      pinScrewBack: Number(pinScrewBack || 0),
      pinPlasticClasp: Number(pinPlasticClasp || 0),
      pinCards: Number(pinCards || 0),
      note,
    });
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-card">
        <div className="gear-modal-header">Aktualizacja zasobów</div>
        <div className="modal-body">
          <label>
            Naklejki duże
            <input
              type="number"
              min={0}
              value={stickersLarge}
              onChange={(e) => setStickersLarge(e.target.value)}
            />
          </label>
          <label>
            Naklejki małe
            <input
              type="number"
              min={0}
              value={stickersSmall}
              onChange={(e) => setStickersSmall(e.target.value)}
            />
          </label>
          <label>
            Naszywki
            <input
              type="number"
              min={0}
              value={patches}
              onChange={(e) => setPatches(e.target.value)}
            />
          </label>
          <label>
            Wizytówki
            <input
              type="number"
              min={0}
              value={businessCards}
              onChange={(e) => setBusinessCards(e.target.value)}
            />
          </label>
          <label>
            Pin (metalowe zapięcie)
            <input
              type="number"
              min={0}
              value={pinMetalClasp}
              onChange={(e) => setPinMetalClasp(e.target.value)}
            />
          </label>
          <label>
            Pin (wkrętka)
            <input
              type="number"
              min={0}
              value={pinScrewBack}
              onChange={(e) => setPinScrewBack(e.target.value)}
            />
          </label>
          <label>
            Pin (plastikowe zapięcie)
            <input
              type="number"
              min={0}
              value={pinPlasticClasp}
              onChange={(e) => setPinPlasticClasp(e.target.value)}
            />
          </label>
          <label>
            Kartoniki do pinów
            <input
              type="number"
              min={0}
              value={pinCards}
              onChange={(e) => setPinCards(e.target.value)}
            />
          </label>
          <label className="full-width">
            Powód / notatka
            <textarea value={note} onChange={(e) => setNote(e.target.value)} />
          </label>
        </div>
        <div className="modal-actions">
          <div className="btn" onClick={onClose}>
            Anuluj
          </div>
          <button className="btn primary" onClick={handleSubmit}>
            Zapisz
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateConsumablesModal;
